export function checkFileExtension(fileName: string, triggredExtension: string) {
    const ext = fileName.split('.').pop();
    return ext === triggredExtension ? fileName : "not found"
}